import Dialog from '@mui/material/Dialog';
import React, { useMemo } from 'react';

import { DeleteGoalError } from './delete-goal-error';
import { DeleteGoalLoading } from './delete-goal-loading';
import { DeleteGoalMessage } from './delete-goal-message';

export type DeleteGoalDialogProps = {
  open: boolean;
  name: string;
  isProject?: boolean;
  onClose: () => void;
  onSubmit: () => void;
  onRetry: () => void;
  isLoading?: boolean;
  isError?: boolean;
};

export const DeleteGoalDialog: React.FC<DeleteGoalDialogProps> = ({
  open,
  name,
  isProject,
  onClose,
  onRetry,
  onSubmit,
  isLoading,
  isError,
}) => {
  const content = useMemo(() => {
    if (isError) {
      return (
        <DeleteGoalError name={name} onRetry={onRetry} onCancel={onClose} />
      );
    }

    if (isLoading) {
      return <DeleteGoalLoading />;
    }

    return (
      <DeleteGoalMessage
        name={name}
        isProject={isProject}
        onSubmit={onSubmit}
        onCancel={onClose}
      />
    );
  }, [isError, isLoading, isProject, name, onClose, onRetry, onSubmit]);

  return (
    <Dialog open={open} fullWidth onClose={!isLoading ? onClose : undefined}>
      {content}
    </Dialog>
  );
};
